import { useEffect, useState } from "react";
import CampaignService from "../services/CampaignService";

/**
 * Provides the known campaign codes (e.g. "OPS-MYS") used by PII detection
 * to flag campaign identifiers typed into coaching-form fields.
 */
const useCampaignCodes = () => {
  const [campaignCodes, setCampaignCodes] = useState([]);

  useEffect(() => {
    let active = true;
    CampaignService.getKnownCampaignCodes().then(codes => {
      if (active) setCampaignCodes(codes);
    });
    return () => {
      active = false;
    };
  }, []);

  return campaignCodes;
};

export default useCampaignCodes;
